import { getSdSellPrice } from "../../application-steps/scripts/modules/StampDuty";
class InsuranceTierData {
    constructor(tiers, state) {
        this.tiers = tiers;
        this.state = state;
    }

    getProductsPerTier() {
        let groupedInsurances = [];
        this.tiers.forEach(tier => {
            // sampling the tier inside the collection
            let price = getSdSellPrice(
                Number(
                    tier[0].max_amount_localised
                        ? tier[0].max_amount_localised[this.state] || 0
                        : 0
                ),
                tier[0],
                this.state,
                tier[0].is_stamp_duty_available || false
            );

            let insuranceType = {
                name: tier[0].title,
                insurance_id: tier[0].insurance_id,
                id: tier[0].id,
                options: [],
                selected: null,
                price: Number(price).toFixed(2)
            };

            tier.forEach((optionItem, index) => {
                let item = {
                    insurance: optionItem.insurance,
                    insurance_id: optionItem.insurance_id,
                    label: optionItem.name,
                    loading: optionItem.loading,
                    value: optionItem.id,
                    is_stamp_duty_available:
                        optionItem.is_stamp_duty_available || false,
                    sd: {
                        // stamp duty shits
                        act_sd: optionItem.act_sd || 0,
                        qld_sd: optionItem.qld_sd || 0,
                        sa_sd: optionItem.sa_sd || 0,
                        nt_sd: optionItem.nt_sd || 0,
                        vic_sd: optionItem.vic_sd || 0,
                        wa_sd: optionItem.wa_sd || 0,
                        nsw_sd: optionItem.nsw_sd || 0,
                        tas_sd: optionItem.tas_sd || 0
                    },
                    price: Number(
                        getSdSellPrice(
                            Number(
                                optionItem.max_amount_localised
                                    ? optionItem.max_amount_localised[
                                    this.state
                                    ] || 0
                                    : 0
                            ),
                            optionItem,
                            this.state,
                            optionItem.is_stamp_duty_available || false
                        )
                    ).toFixed(2),
                    min: Number(
                        optionItem.min_amount_localised
                            ? optionItem.min_amount_localised[this.state]
                            : 0 || 0
                    ).toFixed(2),
                    max: Number(
                        optionItem.min_amount_localised
                            ? optionItem.max_amount_localised[this.state]
                            : 0 || 0
                    ).toFixed(2),
                    preCommission: optionItem.pre_commission
                        ? Number(optionItem.pre_commission[this.state]).toFixed(
                            2
                        )
                        : 0
                };

                insuranceType.options.push(item);
            });

            groupedInsurances.push(insuranceType);
        });

        // console.warn('groupedInsurances', groupedInsurances)

        return groupedInsurances;
    }
}

export default InsuranceTierData;
